import Button from "../Button";
import { CartDetails } from "../../lib/cart/CartDetails";
import FoundryLink from "../../components/FoundryLink";
import FoundryPhysicalProduct from "../../lib/foundry_client/models/FoundryPhysicalProduct";
import Routes from "../../routes";
import { toast } from "react-toastify";
import { useState } from "react";

interface AddToCartProps {
  onClick: () => any;
  extraClasses?: string;
}

export default function AddToCartButton({
  onClick,
  extraClasses,
}: AddToCartProps) {
  const [added, setAdded] = useState(false);

  return (
    <Button
      classes={`col-span-1 self-start py-2 2xl:py-3 px-8 transition-colors ${extraClasses} ${
        added
          ? "bg-green border-green color-secondary cursor-default"
          : "border-primary bg-fedblue-hover border-fedblue-hover color-secondary-hover"
      }`}
      onClick={() => {
        // TODO: validate state
        const success = onClick();

        if (success) {
          toast.success(
            <div className="flex flex-col gap-1">
              <span className="t7">Successfully added items.</span>{" "}
              <span className="text-sm underline underline-offset-4 color-blue-hover">
                <FoundryLink href={Routes.cart.index}>→ view cart</FoundryLink>
              </span>
            </div>
          );
          setAdded(true);
        }
      }}
    >
      <span>{added ? "Added!" : "Add to Cart"}</span>
    </Button>
  );
}
